import { render, staticRenderFns } from "./OperationMalfunction.vue?vue&type=template&id=96bfcc46&scoped=true"
import script from "./OperationMalfunction.vue?vue&type=script&lang=js"
export * from "./OperationMalfunction.vue?vue&type=script&lang=js"
import style0 from "./OperationMalfunction.vue?vue&type=style&index=0&id=96bfcc46&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96bfcc46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96bfcc46')) {
      api.createRecord('96bfcc46', component.options)
    } else {
      api.reload('96bfcc46', component.options)
    }
    module.hot.accept("./OperationMalfunction.vue?vue&type=template&id=96bfcc46&scoped=true", function () {
      api.rerender('96bfcc46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Operation/OperationMalfunction/OperationMalfunction.vue"
export default component.exports